//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../no/Object.js";
import "../no/Session.js";
let d=[[],[[[],"NewTracelinkQuery",{R_:{tracelink_query:"PDM.TracelinkQuery"}},0,0],[["requirement_item_numbers","requirement_revisions","parts"],"CreateTraceLinks",{},3,0],[["requirement_item_numbers","requirement_revisions","parts"],"RemoveTraceLinks",{},3,0]],[]];
SPLM.PDM.RequirementUtils = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.PDM.RequirementUtils";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;